import { useEffect } from 'react';
import { useInfiniteQuery } from '@tanstack/react-query';
import { endpoints } from '@rossum/api-client';
import { api } from '../../../lib/apiClient';
import { STALE_TIME } from './config';

export const useGetQueues = () => {
  const queuesPaginatedQuery = useInfiniteQuery({
    queryKey: ['queues-paginated'],
    queryFn: ({ pageParam = 1 }) => {
      const endpoint = endpoints.queues.list({
        pageSize: 100,
        page: pageParam,
        fields: ['id', 'name', 'schema', 'url', 'workspace', 'engine'],
      });

      return api.request(endpoint);
    },

    getNextPageParam: (lastPage, pages) =>
      pages.length < lastPage.pagination.totalPages
        ? pages.length + 1
        : undefined,

    staleTime: STALE_TIME,
  });

  const { isFetching, hasNextPage, fetchNextPage, isError } =
    queuesPaginatedQuery;

  useEffect(() => {
    if (!isFetching && hasNextPage && !isError) {
      fetchNextPage();
    }
  }, [isFetching, hasNextPage, fetchNextPage, isError]);

  // TO-DO: Check this one to use better type
  return queuesPaginatedQuery;
};
